import { useSelector } from 'react-redux';

export const useMySchoolId = () => {
  const mySchoolId = useSelector((state) => (state as any).auth.schoolId);

  return mySchoolId;
};
